e4.product = {
    debug: false,
    init: function () {
        if (jQuery('.js-e-product-form, .js-e-productlist').length > 0) {
            e4.require.js(e4.settings.require.jQueryValidate, function () {
                e4.product.bindEvents();
                e4.product.variants.init();
            });
        }
    },
    bindEvents: function () {
        jQuery('.js-e-product-form').each(function (intIndex, domForm) {
            e4.product.validateForm(domForm);
        });

        jQuery('.js-mch365-btn-opdate-cart').on('click', function (event) {
            event.preventDefault();
            e4.product.addSingleSelectBoothItemToCart(event);
        });
        
        jQuery('.js-e-productlist').on('click', '.js-mch365-product-modal-trigger', function(event){
            console.log('__disable-modal', jQuery(event.target).closest('.js-disable-modal-trigger'));
            if (jQuery(event.target).closest('.js-disable-modal-trigger').length === 0){
                const modalTarget = jQuery(event.currentTarget).data('target');
                let jqXHR = jQuery.ajax({
                    method: 'POST',
                    url: '/system/data/modalproductdetail',
                    data: jQuery(event.currentTarget).data(),
                    dataType: 'html',
                    cache: false
                });

                jqXHR.done(function (html) {
                    jQuery('.js-mch365-product-detail').html(html);
                    jQuery(modalTarget).modal('show');
                });
            }
        });
        
        jQuery(document).on('input', '.js-mch365-order-comment-textarea', function(event){
            if (!jQuery(event.currentTarget).hasClass('add-to-cart')){
                jQuery(event.currentTarget).addClass('add-to-cart');
            }
        });
        jQuery('.js-e-productlist')
            .on('builded.e4.productlist', function (event) {
                jQuery(event.target).find('.js-e-product-form').each(function (intIndex, domForm) {
                    e4.product.validateForm(domForm);
                });
            })
            .on('input', '.js-mch365-booth-item-quantity[max]', function(event){
                var jQuantityInput = jQuery(event.currentTarget),
                    quantityMax = parseInt(jQuantityInput.prop('max'), 10),
                    quantityVal = parseInt(jQuantityInput.val(), 10);
                if (quantityVal > quantityMax){
                    jQuantityInput.val(quantityMax);
                }
            })
            .on('change', '.js-mch365-product-item-input-select', function (event) {
                let jInput = jQuery(event.currentTarget);
                if (jInput.prop('checked')) {
                    jInput.closest('.js-e-productlist').find('.js-mch365-product-item-input-select').removeClass('add-to-cart');
                    jInput.addClass('add-to-cart');
                }
                e4.product.updateGroupNavigation();
            })
            .on('submit', '.js-mch365-booth-product-addtocart-form', function (event) {
                event.preventDefault();
                e4.product.addBoothItemToCart(event);
            })
            .on('click', '.js-mch365-shop-variant-list-addtocart-btn', function (event) {
                event.preventDefault();
                e4.product.addVariantsToCart(event);
            });
        jQuery('.js-e-product-images, #js-e-product-image-modal').on('loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function (event) {
            jQuery(event.target).on('mouseenter', '.carousel-indicators li', function (event) {
                jQuery(event.target).trigger('click');
            });
        });
        jQuery('.js-e-product-images').find('.js-e-jsonpublisher').on('load.e4.jsonpublisher', function (event) {
            jQuery(event.target).addClass('is-loading');
        }).on('loaded.e4.jsonpublisher', function (event) {
            jQuery(event.target).removeClass('is-loading');
        });

        e4.product.updateGroupNavigation();
    },
    validateForm: function (domForm) {
        var jForm = jQuery(domForm);
        jForm.validate({
            submitHandler: function (domForm) {
                if (jForm.is('.js-e-product-form-removefromcart') === true) {
                    e4.product.removeFromCart(domForm);
                } else /* if ( jForm.is( '.js-e-product-form-addtocart' ) === true )*/ {
                    e4.product.addToCart(domForm);
                }
            }
        });
    },
    updateGroupNavigation: function () {
        let productLists = jQuery('.js-e-productlist').filter(function (intIndex, domListElement) {
            return jQuery(domListElement).find('.js-mch365-product-item-input-select').length > 0;
        });

        let missingSelection = productLists.filter(function (intIndex, domListElement) {
            return jQuery(domListElement).find('.js-mch365-product-item-input-select:checked').length === 0;
        });

        if (missingSelection.length === 0) {
            jQuery('.js-mch365-btn-opdate-cart').removeClass('disabled');
        } else {
            jQuery('.js-mch365-btn-opdate-cart').addClass('disabled');
        }
    },
    getAddedDateTimeValue: function () {
        const date = new Date(Date.now());
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        const formattedDate = day + '-' + month + '-' + year + ' ' + hours + ':' + minutes + ':' + seconds;
        return formattedDate;
    },
    addSingleSelectBoothItemToCart: function (event) {
        let jBtnElement = jQuery(event.currentTarget);
        let jInputSelectedProducts = jQuery('.js-mch365-product-item-input-select.add-to-cart:checked');
        let jFirstProductItem = jQuery('.js-mch365-productlists-container').find('.js-mch365-product-item').first();
        let postData = {};
        let boolPostData = false;
        let orderContext = jFirstProductItem.find('input[name="OrderContext"]').val();
        console.log('__orderContext', orderContext);
        let dataUrl = e4.cart.getDataUrlFromOrderContext(orderContext);
        postData['CartCmd'] = 'addmulti';
        postData['OrderContext'] = orderContext;
        postData['Redirect'] = 'false';

        jInputSelectedProducts.each(function (intIndex, docElement) {
            boolPostData = true;
            let jProductItem = jQuery(docElement).closest('.js-mch365-product-item');
            postData['ProductLoopCounter' + intIndex] = intIndex;
            postData['ProductID' + intIndex] = jProductItem.find('input[name="ProductID"]').val();
            postData['VariantID' + intIndex] = jProductItem.find('input[name="VariantID"]').val();
            postData['UnitID' + intIndex] = '';
            postData['Quantity' + intIndex] = jProductItem.find('input[name="Quantity"]').val();
            postData['EcomOrderLineFieldInput_OrderlineAddedDateTime' + intIndex] = e4.product.getAddedDateTimeValue();
        });

        jQuery('.js-mch365-order-comment-textarea.add-to-cart').each(function (intIndex, docElement) {
            boolPostData = true;
            let jTextarea = jQuery(docElement)
            postData[jTextarea.attr('name')] = jTextarea.val();
        });

        if (boolPostData) {
            e4.cart.ajax({
                url: dataUrl,
                data: postData,
                beforeSend: function () {
                }
            }, function (jsonData) {

                jQuery(document).trigger(e4.cart.event.productadded, jsonData);
                setTimeout(function () {
                    e4.product.nextAction(jBtnElement);
                }, 4000);
            });
        } else {
            e4.product.nextAction(jBtnElement);
        }

    },
    nextAction: function (jBtnElement) {
        if (jBtnElement.data('href') !== undefined) {
            location.href = jBtnElement.data('href');
        }
        if (jBtnElement.data('openPlacementModal') === true) {
            jQuery('#js-mch365-booth-modal').modal('show');
        }
    },
    addVariantsToCart: function (event) {
        let quantityInputs = jQuery('.js-e-productlist').find('.js-mch365-booth-variant-item-quantity').filter(function (intIndex, domListElement) {
            let inputValue = jQuery(domListElement).val();
            return !isNaN(inputValue) && inputValue > 0;
        });

        if (quantityInputs.length > 0) {
            let firstInputGroup = quantityInputs.first().closest('.js-mch365-inputs-container');
            let jProductList = firstInputGroup.closest('.js-e-productlist');
            let orderContext = firstInputGroup.find('input[name="OrderContext"]').val();
            let dataUrl = e4.cart.getDataUrlFromOrderContext(orderContext);
            let currentDateTime = e4.product.getAddedDateTimeValue();
            let postData = {};
            let intPostIndex = 0;
            postData['CartCmd'] = firstInputGroup.find('input[name="CartCmd"]').val();
            postData['OrderContext'] = orderContext;
            postData['Redirect'] = 'false';

            quantityInputs.each(function (intIndex, domInput) {
                let jInputGroup = jQuery(domInput).closest('.js-mch365-inputs-container');
                let isPlaceable = jInputGroup.find('input[name="IsPlaceable"]').val() === 'True';
                let intQuantity = jInputGroup.find('input[name="Quantity"]').val();
                if (isPlaceable) {
                    for (let intIndex = 0; intIndex < intQuantity; intIndex++) {
                        postData['ProductLoopCounter' + intPostIndex] = intPostIndex;
                        postData['ProductID' + intPostIndex] = jInputGroup.find('input[name="ProductID"]').val();
                        postData['VariantID' + intPostIndex] = jInputGroup.find('input[name="VariantID"]').val();
                        postData['UnitID' + intPostIndex] = '';
                        postData['Quantity' + intPostIndex] = 1;
                        postData['EcomOrderLineFieldInput_OrderlineBoothIconText' + intPostIndex] = jInputGroup.find('input[name="IconText"]').val();
                        postData['EcomOrderLineFieldInput_OrderlineBoothUniqueID' + intPostIndex] = currentDateTime + '_' + Math.random();
                        postData['EcomOrderLineFieldInput_OrderlineAddedDateTime' + intPostIndex] = currentDateTime;
                        ++intPostIndex;
                    }
                } else {
                    postData['ProductLoopCounter' + intPostIndex] = intPostIndex;
                    postData['ProductID' + intPostIndex] = jInputGroup.find('input[name="ProductID"]').val();
                    postData['VariantID' + intPostIndex] = jInputGroup.find('input[name="VariantID"]').val();
                    postData['UnitID' + intPostIndex] = '';
                    postData['Quantity' + intPostIndex] = intQuantity;
                    //postData['EcomOrderLineFieldInput_OrderlineAddedDateTime'+intPostIndex] = currentDateTime;
                    ++intPostIndex;
                }
            });

            e4.cart.ajax({
                url: dataUrl,
                data: postData,
                beforeSend: function () {
                    jProductList.find('.js-mch365-product-list-preloader').addClass('is-loading opacity-60');
                }
            }, function (jsonData) {
                console.log('__jsonData.added.1', jsonData);
                jQuery(document).trigger(e4.cart.event.productadded, jsonData);
                jProductList.find('.js-mch365-booth-variant-item-quantity').val('');
                jProductList.find('.js-mch365-product-list-preloader').removeClass('is-loading opacity-60');
            });

            console.log('__postData', postData);
            //js-mch365-inputs-container
            //js-mch365-booth-variant-item-quantity
        }
    },
    addBoothItemToCart: function (event) {
        let currentDateTime = e4.product.getAddedDateTimeValue();
        let jForm = jQuery(event.currentTarget);
        let isPlaceable = jForm.find('input[name="IsPlaceable"]').val() === 'True';
        let jProductItem = jForm.closest('.js-mch365-product-item');
        let intQuantity = jForm.find('.js-mch365-booth-item-quantity').val();
        let orderContext = jForm.find('input[name="OrderContext"]').val();
        let dataUrl = e4.cart.getDataUrlFromOrderContext(orderContext);
        if (!isNaN(intQuantity) && intQuantity.length > 0) {
            let postData = {};
            postData['CartCmd'] = jForm.find('input[name="CartCmd"]').val();
            postData['OrderContext'] = orderContext;
            postData['Redirect'] = 'false';
            if (isPlaceable) {
                for (let intIndex = 0; intIndex < intQuantity; intIndex++) {
                    postData['ProductLoopCounter' + intIndex] = intIndex;
                    postData['ProductID' + intIndex] = jForm.find('input[name="ProductID"]').val();
                    postData['VariantID' + intIndex] = jForm.find('input[name="VariantID"]').val();
                    postData['UnitID' + intIndex] = '';
                    postData['Quantity' + intIndex] = 1;
                    postData['EcomOrderLineFieldInput_OrderlineComment' + intIndex] = jForm.find('textarea[name="Comment"]').val();
                    postData['EcomOrderLineFieldInput_OrderlineBoothIconText' + intIndex] = jForm.find('input[name="IconText"]').val();
                    postData['EcomOrderLineFieldInput_OrderlineBoothUniqueID' + intIndex] = currentDateTime + '_' + Math.random();
                    postData['EcomOrderLineFieldInput_OrderlineAddedDateTime' + intIndex] = currentDateTime;
                }
            } else {
                postData['ProductLoopCounter0'] = '0';
                postData['ProductID0'] = jForm.find('input[name="ProductID"]').val();
                postData['VariantID0'] = jForm.find('input[name="VariantID"]').val();
                postData['UnitID0'] = '';
                postData['Quantity0'] = intQuantity;
                postData['EcomOrderLineFieldInput_OrderlineComment0'] = jForm.find('textarea[name="Comment"]').val();
                //postData['EcomOrderLineFieldInput_OrderlineAddedDateTime0'] = currentDateTime;
            }

            e4.cart.ajax({
                url: dataUrl,
                data: postData,
                beforeSend: function () {
                    jProductItem.find('.js-mch365-product-item-preloader').addClass('is-loading opacity-60');
                }
            }, function (jsonData) {
                console.log('__jsonData.added.0', jsonData);
                jQuery(document).trigger(e4.cart.event.productadded, jsonData);
                let intQuantityInCart = parseInt(jProductItem.find('.js-mch365-quantity-in-cart').text()) + parseInt(intQuantity);
                jForm.find('.js-mch365-booth-item-quantity').val('1');
                jProductItem.find('.js-mch365-quantity-in-cart').text(intQuantityInCart);
                jProductItem.find('.js-mch365-quantity-in-cart-container').removeClass('d-none');
                jProductItem.find('.js-mch365-product-item-preloader').removeClass('is-loading opacity-60');
                if (jsonData.cart.context === 'Booth' && jQuery('.js-mch365-placement-msg').length > 0) {
                    jQuery('.js-mch365-placement-msg').html(e4.handlebars.tmpl.placementMsg(jsonData));
                }
            });
        }
    },
    addToCart: function (domForm) {
        var jForm = jQuery(domForm),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for (var i = 0; i < arrFormData.length; i++) {
            objFormData[arrFormData[i].name] = arrFormData[i].value;
        }
        jQuery.extend(objFormData, {
            Redirect: false
        });
        if (jForm.is('.js-e-product-form-download') === true) {
            e4.download.cart.addProduct(objFormData);
        } else {
            e4.cart.addProduct(objFormData);
        }
    },
    removeFromCart: function (domForm) {
        var jForm = jQuery(domForm),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for (var i = 0; i < arrFormData.length; i++) {
            objFormData[arrFormData[i].name] = arrFormData[i].value;
        }
        jQuery.extend(objFormData, {
            Redirect: false
        });
        if (jForm.is('.js-e-product-form-download') === true) {
            e4.download.cart.removeProduct(objFormData);
        } else {
            e4.cart.removeProduct(objFormData);
        }
    }
};
